var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.dataBinAssignment.DETAILS
    ? _c(
        "div",
        { staticClass: "class-page" },
        [
          _c("ClassPageHeader", {
            attrs: {
              details: _vm.details,
              "current-section": parseInt(_vm.sectionId),
              course: _vm.course,
              menu: _vm.menu,
              "is-class-item-page": true
            }
          }),
          _vm._v(" "),
          !!_vm.response
            ? [
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "margin-left": "0", "margin-right": "0" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 alert alert-info alert-success"
                      },
                      [_vm._v("\n\t\t\t\t" + _vm._s(_vm.response) + "\n\t\t\t")]
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "assignment-bin" }, [
            _c("div", { staticClass: "display-table submission-page" }, [
              _c("div", { staticClass: "display-container" }, [
                _c("div", { staticClass: "header color-status" }, [
                  _c(
                    "div",
                    {
                      class:
                        "pill float-left " +
                        _vm.dueSoon(_vm.dataBinAssignment.ASSIGNMENT_END_DATE)
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.AssignmentBin.due", {
                              date: _vm.dateFormat(
                                _vm.dataBinAssignment.ASSIGNMENT_END_DATE
                              )
                            })
                          ) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "score-pill float-right" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("MAIN_CONTENT.commonContent.score")) +
                        " \n\t\t\t\t\t\t"
                    ),
                    !!_vm.dataBinAssignment.DETAILS.MAX_POINTS
                      ? _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AssignmentBin.gradeOverPoints",
                                  {
                                    grade:
                                      _vm.dataBinAssignment.DETAILS.GRADE_CODE,
                                    points:
                                      _vm.dataBinAssignment.DETAILS.MAX_POINTS
                                  }
                                )
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      : _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("MAIN_CONTENT.AssignmentBin.hyphen"))
                          )
                        ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sub-header" }, [
                  _c("div", [
                    _c("a", [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.dataBinAssignment.ASSIGNMENT_NAME))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "float-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "pointer",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goToSubmissions()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AssignmentBin.mySubmissions"
                                )
                              ) +
                              " \n\t\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "pill pill-submissions" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.dataBinAssignment.SUBMISSIONS.length
                                ) +
                                "\n\t\t\t\t\t\t\t\t"
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "description",
                      domProps: {
                        innerHTML: _vm._s(_vm.dataBinAssignment.ASSIGNMENT_DESC)
                      }
                    }),
                    _vm._v(" "),
                    _vm.dataBinAssignment.ATTACHMENTS.length
                      ? _c(
                          "div",
                          {
                            staticClass: "attached",
                            staticStyle: { padding: "10px" }
                          },
                          [
                            _c("h3", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.AssignmentBin.attachedFiles"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "badge badge-dark" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dataBinAssignment.ATTACHMENTS.length
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.dataBinAssignment.ATTACHMENTS, function(
                              attachment,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "attached-file" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: attachment.ATTACHMENT_URL,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-word",
                                        attrs: { "aria-hidden": "true" }
                                      }),
                                      _vm._v(
                                        " \n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.AssignmentBin.bytesMessage",
                                              {
                                                name: attachment.REPORT_NAME,
                                                size: attachment.CONTENT_SIZE
                                              }
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("aria-new-tab-message", {
                                        attrs: {
                                          message: _vm.$t(
                                            "MAIN_CONTENT.Accessibility.opensInNewTab"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.role === "student" &&
              !_vm.hasReachedSubmissionLimit &&
              (!_vm.isExpired(_vm.dataBinAssignment.ASSIGNMENT_END_DATE) ||
                _vm.dataBinAssignment.ALLOW_LATE_SUBMISSION === "Y") &&
              (_vm.dataBinAssignment.ALLOW_FILE_SUBMISSION === "Y" ||
                _vm.dataBinAssignment.ALLOW_TEXT_SUBMISSION === "Y")
                ? _c("div", { staticClass: "add-submission" }, [
                    _c("h3", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.Submission.addSubmission")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "display-container" }, [
                      _c("div", { staticClass: "new-submission" }, [
                        _vm.dataBinAssignment.ALLOW_TEXT_SUBMISSION === "Y"
                          ? _c("div", { staticClass: "text-submission" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("h4", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.Submission.textSubmissionColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "details" },
                                [
                                  _c("ckeditor4", {
                                    attrs: {
                                      config: _vm.editorConfig,
                                      simpleImagesDialog: true,
                                      id: "reply-message"
                                    },
                                    model: {
                                      value: _vm.text,
                                      callback: function($$v) {
                                        _vm.text = $$v
                                      },
                                      expression: "text"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataBinAssignment.ALLOW_FILE_SUBMISSION === "Y"
                          ? _c("div", { staticClass: "attach-submission" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("h4", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.AssignmentBin.attachedFilesColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "details" }, [
                                _c("div", { staticClass: "buttons" }, [
                                  _vm.dataBinAssignment.NO_FILES_ALLOWED === "O"
                                    ? _c("h3", { staticClass: "text-center" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.Submission.oneFileUpload"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm.loadedFilePickerData
                                  ? _c(
                                      "div",
                                      { staticClass: "dropzone-area" },
                                      [
                                        _vm.showFileUploader
                                          ? _c("file-uploader", {
                                              ref: "fileUpload",
                                              attrs: {
                                                nameHeader: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.name"
                                                ),
                                                sizeHeader: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.size"
                                                ),
                                                removeHeader: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.remove"
                                                ),
                                                dropSingleFile: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.dropSingleFile"
                                                ),
                                                dropMultipleFiles: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.dropMultipleFiles"
                                                ),
                                                selectSingleFile: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.selectSingleFile"
                                                ),
                                                selectMultipleFiles: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.selectMultipleFiles"
                                                ),
                                                attachFile: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.attachFile"
                                                ),
                                                attachFiles: _vm.$t(
                                                  "MAIN_CONTENT.commonContent.attachFiles"
                                                ),
                                                files: _vm.files,
                                                size:
                                                  _vm.dataBinAssignment
                                                    .MAX_SUBMISSION_SIZE,
                                                multiple:
                                                  _vm.dataBinAssignment
                                                    .NO_FILES_ALLOWED === "U",
                                                URL: _vm.externalFileData,
                                                postAction: _vm.fileUploadToken
                                              },
                                              on: {
                                                updateFiles: _vm.updateValue,
                                                saveGoogleFilesData: function(
                                                  $event
                                                ) {
                                                  return _vm.saveGoogleFileData(
                                                    (_vm.file = $event),
                                                    (_vm.multiple =
                                                      _vm.dataBinAssignment
                                                        .NO_FILES_ALLOWED ===
                                                      "U")
                                                  )
                                                },
                                                saveDropboxFilesData: function(
                                                  $event
                                                ) {
                                                  return _vm.saveDropboxFileData(
                                                    (_vm.file = $event),
                                                    (_vm.multiple =
                                                      _vm.dataBinAssignment
                                                        .NO_FILES_ALLOWED ===
                                                      "U")
                                                  )
                                                },
                                                saveOneDriveFilesData: function(
                                                  $event
                                                ) {
                                                  return _vm.saveOneDriveFileData(
                                                    (_vm.file = $event),
                                                    (_vm.multiple =
                                                      _vm.dataBinAssignment
                                                        .NO_FILES_ALLOWED ===
                                                      "U")
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "submission-actions" }, [
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-cancel",
                              on: { click: _vm.reset }
                            },
                            [
                              _vm._v(
                                " \n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("commonText.cancel")) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-submit",
                              attrs: {
                                disabled:
                                  !_vm.dirty ||
                                  (_vm.files.length === 0 &&
                                    _vm.text.length === 0)
                              },
                              on: { click: _vm.save }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.commonContent.submit")
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm.hasReachedSubmissionLimit
                ? _c("div", [
                    _c("p", { staticClass: "text-danger text-center" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.Submission.onlyOneSubmission")
                        )
                      )
                    ])
                  ])
                : _c("div", [
                    _c("p", { staticClass: "text-danger text-center" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.Submission.assignmentBinClosed")
                        )
                      )
                    ])
                  ]),
              _vm._v(" "),
              !!_vm.dataBinAssignment.FEEDBACK.FEEDBACK_TEXT
                ? _c("div", { staticClass: "feedback" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-feedback",
                        on: {
                          click: function($event) {
                            return _vm.goToFeedback(_vm.assignment)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.AssignmentBin.seeFeedback")
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "my-submissions",
                  attrs: { id: "assignment_bin_submissions" }
                },
                [
                  _c("h3", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.AssignmentBin.mySubmissions")
                        ) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataBinAssignment.SUBMISSIONS, function(
                    submission
                  ) {
                    return _c(
                      "div",
                      {
                        key: submission.SUBMISSION_ID,
                        staticClass: "display-container"
                      },
                      [
                        _c("div", { staticClass: "header" }, [
                          _c("h4", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(submission.CREATED_DATE) +
                                "\n\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        submission.ATTACHMENTS.length
                          ? _c(
                              "div",
                              { staticClass: "attached" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.Submission.submittedFiles"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(submission.ATTACHMENTS, function(
                                  attachment,
                                  i
                                ) {
                                  return _c(
                                    "div",
                                    { key: i, staticClass: "attached-file" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: attachment.ATTACHMENT_URL,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            class:
                                              "fas " +
                                              _vm.fileType(
                                                attachment.CONTENT_ID
                                              ),
                                            attrs: { "aria-hidden": "true" }
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                attachment.CONTENT_FILENAME
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("aria-new-tab-message", {
                                            attrs: {
                                              message: _vm.$t(
                                                "MAIN_CONTENT.Accessibility.opensInNewTab"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        submission.TEXT_SUBMISSION !== ""
                          ? _c("div", { staticClass: "submission-text" }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.Submission.textSubmission"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-box" }, [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      submission.TEXT_SUBMISSION
                                    )
                                  }
                                })
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "back-link" }, [
                _c(
                  "a",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.reset }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-caret-left",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }